module.exports = __webpack_public_path__ + "static/icons/icon-point--red-914e637c05dcc01602fa1c572efb7f7f.svg";